const mutations = {
  setUser (state, data) {
    state.user = data
    state.authenticated = true
  },
  logOut (state) {
    state.user = []
    state.authenticated = false
  }
}

export default mutations
